import { Directive } from '@angular/core';
import { PlaceDetails } from 'src/app/_types/household.types';
import { HouseholdMetadata } from 'src/app/_types/lead.types';
import {
  getHouseholdAdditionalCoverLabel,
  getHouseholdBuildingTypeLabel,
  getHouseholdCoversLabel,
  getHouseholdLiabilityLabel,
  getHouseTypeLabel,
  getOwnershipConditionLabel,
} from 'src/app/enums/household.enum';
import { compareArrays, getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class HouseholdMetadataComponentAbstract extends BaseMetadataComponent<HouseholdMetadata> {
  getHouseTypeLabel = getHouseTypeLabel;

  getHouseholdBuildingTypeLabel = getHouseholdBuildingTypeLabel;

  getHouseholdCoversLabel = getHouseholdCoversLabel;

  getHouseholdLiabilityLabel = getHouseholdLiabilityLabel;

  getHouseholdAdditionalCoverLabel = getHouseholdAdditionalCoverLabel;

  getOwnershipConditionLabel = getOwnershipConditionLabel;

  getBooleanLabel = getBooleanLabel;

  compareArrays = compareArrays;

  displayPlaceTypeInfo(info?: PlaceDetails) {
    return (
      info &&
      (info?.address ||
        info?.amountToCover >= 0 ||
        info?.buildingType ||
        info?.description ||
        info?.houseType ||
        info?.postalCode)
    );
  }

  displayQuestionnaire(info?: HouseholdMetadata) {
    return (
      info &&
      ((info?.sufferedClaims !== null && info?.sufferedClaims !== undefined) ||
        (info?.propositionRefused !== null &&
          info?.propositionRefused !== undefined) ||
        (info?.wasInsured !== null && info?.wasInsured !== undefined) ||
        info?.policyNumber ||
        info?.oldCompany)
    );
  }
}
